import React, { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { sectorImages } from '../../constants/images';
import { checkIsMobile } from '../../utils/deviceUtils';
import '../../styles/sections/sector04.css';

const Sector04 = ({ motionProps }) => {
  const [isMobile, setIsMobile] = useState(checkIsMobile(window.innerWidth));
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(checkIsMobile(width));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section 
      className="section_container sector04" 
      style={{ 
        backgroundImage: `url(${isMobile ? sectorImages.sector04.bg.mobile : sectorImages.sector04.bg.pc})`
      }}
    >
      <motion.div 
        className="grid"
        {...motionProps}
      >
        <p className="sec_title">
          <img src={sectorImages.sector04.content.pc} alt="" className="pc_viewer" />
          <img src={sectorImages.sector04.content.mobile} alt="" className="mo_viewer" />
        </p>
      </motion.div>
    </section>
  );
};

Sector04.propTypes = {
  motionProps: PropTypes.shape({
    initial: PropTypes.object,
    whileInView: PropTypes.object,
    viewport: PropTypes.object,
    transition: PropTypes.object
  })
};

export default Sector04; 